import { EmtFooterLink, EmtTypography } from 'emt-components-v2'
import NextMuiLink from '@/components/NextMuiLink'

type Props = {
  href: string
  title: string
}

const FooterNextLink: React.FC<Props> = ({ href, title }) => {
  if (!href?.length || href === '#') {
    return null
  }

  return (
    <EmtFooterLink>
      <NextMuiLink href={href}>
        <EmtTypography variant="body2">{title}</EmtTypography>
      </NextMuiLink>
    </EmtFooterLink>
  )
}

export default FooterNextLink
